"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var DropdownMultiselect_vue_1 = __importDefault(require("./DropdownMultiselect.vue"));
var event_bus_1 = require("../../event-bus");
exports.default = vue_1.default.extend({
    name: "district-multiselect",
    components: {
        DropdownMultiselect: DropdownMultiselect_vue_1.default
    },
    props: {
        options: {
            type: Array,
            required: true
        },
        currentOptions: {
            type: Array,
            required: true
        }
    },
    methods: {
        updateCurrentDistricts: function (options) {
            var optionsArray = options.map(function (option) { return ({ id: option.value, name: option.name }); });
            this.$emit("change", options);
            event_bus_1.EventBus.$emit(event_bus_1.events.district.select, optionsArray);
        }
    }
});
